import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  productId: number
}

class FetchProductDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_PRODUCT_DATA'

    this.config = {
      url: `/v1/product/${params.productId}`,
      method: 'GET',
    }
  }
}

export type ProductDataType = {
  entity: {
    isShow: boolean
    productInfo: any
    skuItemInfo: SkuItemInfoType[]
    specMenu: MenuType[]
  }
}

export type MenuType = {
  name: string
  values: {
    picture: string
    value: string
    disabled: boolean
    hide: boolean
    attrId: number
  }[]
}

export type SkuItemInfoType = {
  skuId: number
  skuNo: string
  stockQuantity: number
  salePrice: number
  origPrice: number
  livePrice: number
  currency: string
  profile: {
    specs: { skuSpecName: string; skuSpecValue: string; nameSort: number; valueSort: number; picture: string; attrId: number; specId: number }[]
    images: string[]
  }
  status: number
  saleQuantity: number
  totalPrice: number
  attrDescp: string
  price: number
  images: string[]
}

export type ProductInfoType = {
  merchantId: string
  merchantName: string
  categoryId: number
  categoryName: string
  currency: string
  productId: number
  productName: string
  productDesc: string
  tags: { style: number; name: string }[]
  minPrice: number
  maxPrice: number
  livePrice: number
  origPrice: number
  status: number
  isHidden?: boolean
  saleQuantity: number
  productDetail: string
  images: string[]
  shippingDays: number
  logistics?: string[]
  minLivePrice: number
  minOrigPrice: number
  maxOrigPrice: number
  price?: string
  linePointFeedback?: boolean
  // 限購（SDC-2344）：綁 product ID，所有規格共用一份額度。判斷邏輯見 @/methods/purchaseLimit
  purchaseLimitQuantity?: number
  purchaseLimitRemaining?: number
  purchaseLimitStartAt?: string
  purchaseLimitEndAt?: string
}

export const fetchProductData = (params: ParamsType) => getCallApiFunction(new FetchProductDataApi(params))
